import { IDanceSchool } from "./danceSchool";
import { IUser } from "./user";

export enum USER_ROLE {
  OWNER = 'Owner',
  ADMIN = 'Admin',
  TEACHER = 'Teacher'
}

export interface IDanceSchoolUser {
  danceSchool: IDanceSchool;
  userId: string;
  role: USER_ROLE
  invitePending: boolean;
  user: IUser;
  defaultHourlyWage?: number | null;
}

export interface IInviteDanceSchoolUserRequest {
  email: string;
  firstName: string;
  lastName: string;
  role: USER_ROLE;
  defaultHourlyWage?: number | null;
}

export interface IAcceptDanceSchoolUserInviteRequest {
  danceSchoolId: string;
}

/** Turning an invitation down. The pending membership row is deleted, so the school can re-invite. */
export interface IDeclineDanceSchoolUserInviteRequest {
  danceSchoolId: string;
}

export interface IRemoveDanceSchoolUserAccessRequest {
  userId: string;
}

export interface IUpdateDanceSchoolUserRoleRequest {
  userId: string;
  role: USER_ROLE;
  defaultHourlyWage?: number | null;
}